import * as React from 'react'
import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// icons
import SectionIconOrigin from '@mui/icons-material/ViewStream'
import ImageIconOrigin from '@mui/icons-material/Wallpaper'
import ChartIconOrigin from '@mui/icons-material/BarChart'
import FunctionIconOrigin from '@mui/icons-material/Functions'
import CardIconOrigin from '@mui/icons-material/Looks5'
import ActionsIconOrigin from '@mui/icons-material/GridView'
// utils
import { darken, size } from 'polished'

const FieldLabel = styled.span`
  margin-left: 8px;
`

const AddFieldButtonWrapper = styled.div`
  color: ${colors.blue500};
  display: inline-flex;
  align-items: center;
  margin: 16px 0;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }

  & > span {
    margin-left: 8px;
    white-space: nowrap;
  }
`

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  > svg:last-child {
    margin-left: auto;
  }
`

const SectionIcon = styled(SectionIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`
const ImageIcon = styled(ImageIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const ChartIcon = styled(ChartIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const FunctionIcon = styled(FunctionIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const CardIcon = styled(CardIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

const ActionsIcon = styled(ActionsIconOrigin)`
  ${size('20px')};

  path {
    fill: ${colors.black};
  }
`

export {
  FieldLabel,
  AddFieldButtonWrapper,
  Wrapper,
  SectionIcon,
  ImageIcon,
  ChartIcon,
  FunctionIcon,
  CardIcon,
  ActionsIcon
}
